import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { WidgetClickedProperties } from './types';

export const trackWidgetClicked = (properties: WidgetClickedProperties) =>
    sendAnalyticsEvent<WidgetClickedProperties>('Widget Clicked', properties);
